


















































































































































































































































































import DatePicker from '@/reusable/Form/DatePicker.vue';
import moment from 'moment';
import Vue from 'vue';
import { fetchDespacho } from './fetchDespacho';
import { AxiosVue } from '@/AxiosVue'; //
import { LoadingService } from '@/services/loadingService';
import { ServicioProxy } from '@/config/enums'; //
import { Component, Prop, Watch } from 'vue-property-decorator';
import { Funcionalidades } from '@/config/funcionalidades';
import { EstadoEntidad } from '@/config/enums';
import Confirmation from '@/components/Confirmation.vue'; //
import { TranslateResult } from 'vue-i18n';
import { GridApi } from 'ag-grid-community';

@Component({
  components: {
    DatePicker,
    'app-confirmacion': Confirmation,
  },
})
export default class EditarDespacho extends Vue {
  @Prop({ default: false }) courrierList!: any;
  @Prop({ default: false }) coordinadorList!: any;
  @Prop({ default: false }) localidadList!: any;
  @Prop({ required: true }) usuarioActivo: any;

  @Prop({ default: false }) edited!: any;
  //@Prop({ default: false }) show!: boolean;
  @Prop({ default: false }) esEdicion!: boolean;
  @Prop({ default: false }) esInformar!: boolean;
  @Prop({ default: false }) esDetalles!: boolean;
  @Prop({
    default: () => ({ id: 0, nombre: '', estado: EstadoEntidad.Activo }),
  })
  getNameModal() {
    if (this.esEdicion) {
      return 'Editar Despacho';
    }
    if (this.esInformar) {
      return 'Informar Recepción Despacho';
    }
    return 'Ver Detalle Despacho';
  }

  tecnicoList: any = [];
  async getTecnico() {
    this.tecnicoList = [];
    this.formFields.tecnico.value = '';
    let self = this;
    this.loadingService.showLoading();
    return fetchDespacho(
      {
        locaid: this.formFields.localidad.value,
      },
      'conectaDespacho/get_tecnico'
    )
      .then((data: any) => {
        if (data.data.CODIGO_RESPUESTA == '1') {
          this.tecnicoList = data.data.data.LISTA;
          return;
        } else {
          self.$snotify.error(data.data.MENSAJE_RESPUESTA, { timeout: 3000 });
        }
      })
      .catch((error: any) => {
        self.$snotify.error('Ocurrió un error', { timeout: 3000 });
      })
      .finally(() => {
        this.loadingService.hideLoading();
        return null;
      });
  }

  accion!: any;
  ordesList2: any;
  data: any = {};
  btnBloquearGuardado: boolean = false;

  async getDespachoSeleccionado() {
    let self = this;
    this.loadingService.showLoading();
    return fetchDespacho({ despanumero: this.edited }, 'conectaDespacho/inicio')
      .then((data: any) => {
        //console.log(data.data.data);
        if (data.data.CODIGO_RESPUESTA == '1') {
          return data.data.data.LISTA;
        } else {
          self.$snotify.error(data.data.MENSAJE_RESPUESTA, { timeout: 3000 });
          return [];
        }
      })
      .catch((error: any) => {
        self.$snotify.error('Ocurrió un error', { timeout: 3000 });
      })
      .finally(() => {
        this.loadingService.hideLoading();
        return null;
      });
  }
  anulado: boolean = false;
  existereceptor: boolean = false;
  existeFechaR: boolean = false;
  async getDespacho() {
    this.ordesList2 = (await this.getDespachoSeleccionado()) || [];
    this.data = this.ordesList2[0];
    this.formFields.localidad.value = this.data.locaid;
    await this.getTecnico();
    this.formFields.usuario.value = this.data.nombre;
    this.formFields.codigo.value = this.data.despanumero;
    this.formFields.tecnico.value = this.data.tecnicoid;
    this.formFields.ordenSeguimiento.value = this.data.despaseguimiento;
    this.formFields.coordinador.value = this.data.coorid;
    this.formFields.courier.value = this.data.despacourrier;
    this.formFields.observacion.value = this.data.despaobs;
    this.formFields.valor.value = this.data.despacargo_valor;
    this.formFields.costo.value =
      this.data.despacargo_sino == '1' ? true : false;
    this.formFields.fechaEnvio.value = moment(this.data.despafecha_envia);
    if (this.data.despafecha_recibe != '') {
      this.existeFechaR = true;
      this.formFields.fechaRecepcion.value = moment(
        this.data.despafecha_recibe
      );
    } else {
      this.existeFechaR = false;
    }
    if (this.data.despareceptor != '') {
      this.formFields.receptor.value = this.data.despareceptor;
      this.existereceptor = true;
    } else {
      this.existereceptor = false;
    }
    if (this.data.case == 'ANULADO') {
      this.formFields.anular.value = 'ANULADO';
      this.esDetalles = true;
      this.existereceptor = true;
      this.existeFechaR = true;
      this.btnBloquearGuardado = true;
    } else {
      this.formFields.anular.value = 'VIGENTE';
    }
  }

  mounted() {
    this.getDespacho();
  }

  onModelUpdated() {
    if (!this.gridApi) {
      return;
    }
  }

  onSelectionChanged(params: any) {}

  formFields: {
    codigo: any;
    fechaEnvio: any;
    usuario: any;
    courier: any;
    ordenSeguimiento: any;
    localidad: any;
    coordinador: any;
    tecnico: any;
    referencia: any;
    observacion: any;
    costo: any;
    valor: any;
    fechaRecepcion: any;
    receptor: any;
    anular: any;
  } = {
    codigo: {
      label: 'Código',
      value: '',
    },
    fechaEnvio: {
      label: 'Fecha Envio',
      value: moment(),
      selectedValue: '',
    },
    usuario: {
      label: 'Usuario',
      value: this.edited.usuarioid,
    },
    courier: {
      label: 'Courier (Obligatorio)',
      value: '',
    },
    ordenSeguimiento: {
      label: 'Orden de Seguimiento (Obligatorio)',
      value: '',
    },
    localidad: {
      label: 'Localidad (Obligatorio)',
      id: 'locaid',
      value: '',
    },
    coordinador: {
      label: 'Coordinador (Obligatorio)',
      id: 'coorid',
      value: '',
    },
    tecnico: {
      label: 'Técnico (Obligatorio)',
      id: 'tecnicoid',
      value: '',
    },
    referencia: {
      label: 'Referencia',
      value: '',
    },
    observacion: {
      label: 'Observación',
      id: 'despaobs',
      value: '',
    },
    costo: {
      label: 'Costo',
      value: false,
    },
    valor: {
      label: 'Valor',
      value: '',
    },
    fechaRecepcion: {
      label: 'Fecha Recepción',
      value: '',
      selectedValue: '',
    },
    receptor: {
      label: 'Receptor',
      value: '',
    },
    anular: {
      label: 'Estado',
      value: 'VIGENTE',
      items: ['VIGENTE', 'ANULADO'],
    },
  };

  //abstract
  readonly funcionalidad: Funcionalidades = Funcionalidades.Despacho;

  //propiedades globales
  loadingService = new LoadingService();
  gridApi: GridApi;
  $snotify: any;
  dialog: boolean = true;
  dialogConfirmacionClose: boolean = false;
  validForm: boolean = false;
  dialogConfirmacion: boolean = false;
  btnBloquear: Boolean = false;
  mensajeConfirmacion: TranslateResult = '';

  //controllers
  readonly controller: string = 'funcionalidad';
  readonly controllerAccion: string = 'accion';
  readonly controllerModuloAccion: string = 'moduloaccion';
  axios: AxiosVue = new AxiosVue(ServicioProxy.GestionUsuario);

  //@Watch('show')
  async onPropertyChanged(value: boolean) {
    this.dialog = value;
    this.dialog = value;
    // permisos
    this.setBotonNav();
  }

  datosEditados: any = {};

  grabarEdicion() {
    this.datosEditados = {
      estado: this.formFields.anular.value,
      despanumero: this.formFields.codigo.value,
      courier: this.formFields.courier.value,
      orden: this.formFields.ordenSeguimiento.value,
      localidad: this.formFields.localidad.value,
      coordinador: this.formFields.coordinador.value,
      tecnico: this.formFields.tecnico.value,
      observacion: this.formFields.observacion.value,
      costo: this.formFields.costo.value,
      valor: parseFloat(this.formFields.valor.value),
      informar: this.esInformar,
      fechaRecepcion:
        this.formFields.fechaRecepcion.value != ''
          ? moment(this.formFields.fechaRecepcion.value).format('YYYY-MM-DD')
          : '',
      receptor: this.formFields.receptor.value,
      usuarioId: this.usuarioActivo.id,
      usuarioRut: this.usuarioActivo.rut,
    };
    if (
      this.datosEditados.curier == '' ||
      this.datosEditados.ordenSeguimiento == '' ||
      this.datosEditados.localidad == '' ||
      this.datosEditados.coordinador == '' ||
      this.datosEditados.tecnico == ''
    ) {
      this.$snotify.error('Por favor ingrese todos los campos obligatorios', {
        timeout: 3000,
      });
      return;
    }
    this.editar();
  }
  async editar() {
    let self = this;
    return fetchDespacho(
      {
        despanumero: this.datosEditados.despanumero,
        fechaRecepcion: this.datosEditados.fechaRecepcion,
        receptor: this.datosEditados.receptor,
        estado: this.datosEditados.estado,
        usuarioId: this.datosEditados.usuarioId,
        usuarioRut: this.datosEditados.usuarioRut,
        courier: this.datosEditados.courier,
        orden: this.datosEditados.orden,
        localidad: this.datosEditados.localidad,
        coordinador: this.datosEditados.coordinador,
        tecnico: this.datosEditados.tecnico,
        observacion: this.datosEditados.observacion,
        costo: this.datosEditados.costo,
        valor: this.datosEditados.valor,
        informar: this.datosEditados.informar,
        clienteId: JSON.parse(localStorage.getItem('user')).clienteDefecto,
      },
      'conectaDespacho/editar'
    )
      .then((data: any) => {
        //console.log(data.data);
        if (data.data.CODIGO_RESPUESTA == '1') {
          self.$snotify.success('Actualización Exitosa', { timeout: 3000 });
          this.closeModal(false);
          return null;
        } else {
          self.$snotify.error(data.data.MENSAJE_RESPUESTA, { timeout: 3000 });
          return [];
        }
      })
      .catch((error: any) => {
        self.$snotify.error('Ocurrió un error', { timeout: 3000 });
      })
      .finally(() => {
        return null;
      });
  }

  setBotonNav() {
    var accion = 'Editar';
    var evaluado = false;

    /* if (this.esEdicion) {
      accion = 'Ver Detalle';
    } else if(!this.esInformar){

    } */
  }

  cierraMenu() {
    var appBanners = document.getElementsByClassName(
      'ag-menu'
    ) as HTMLCollectionOf<HTMLElement>;
    if (appBanners.length > 0) {
      appBanners[0].remove();
    }
  }

  closeModal(val: boolean) {
    this.$validator.reset();
    document.getElementById('cardDivTV').scrollIntoView(true);
    this.$emit('modalAsociacionEmit', false);
    this.$emit('datoEditado', true);
    this.dialog = false;
    this.btnBloquear = false;
  }

  confirmCallback(val: any) {}

  confirmCallbackConfirm(val: boolean) {
    this.dialogConfirmacionClose = false;
    if (val) {
      this.closeModal(false);
    }
  }
}
